export default "__VITE_ASSET__C2RcdtN2__"